import React from 'react';
import { Tabs, Tab, Container } from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import styles from './styles';

const useStyles = makeStyles(styles);

function Stepper(props) {

  const {
    className,
    activeStep,
    customLeftComponent,
    customRightComponent,
    customRightComponentSpace,
    customRightComponent2,
    hasCompletedStepIndicator,
    completedStepTextColor,
    completedStepIndicatorColor,
    containerProps,
    maxWidth,
    disableGutters,
    stepperZIndex,
    disableRipple,
    sticky,
    steps,
    ...rest
  } = props;

  const classes = useStyles(props);

  return (
    <div className={clsx(classes.root, className, { [classes.sticky]: sticky })}>
      <Container className={clsx(classes.stepperWrapper)} maxWidth={maxWidth} disableGutters={disableGutters} {...containerProps}>
        {customLeftComponent}
        <Tabs
          data-test-id="stepper"
          className={clsx(classes.tabs)}
          value={activeStep}
          {...rest}
        >
          {steps.map((step, id) => {
            return (
              <Tab
                className={clsx({ [classes.tab]: true, [classes.completedTab]: activeStep > steps.indexOf(step) })}
                key={`stepper-tab-${id}`}
                data-test-id={`stepper-tab-${id}`}
                disableRipple={disableRipple}
                label={
                  <div
                    className={clsx(classes.tabContent)}
                  >
                    {step}
                    {hasCompletedStepIndicator && activeStep > steps.indexOf(step) && (
                      <DoneIcon fontSize="small" />
                    )}
                  </div>
                }
              />
            );
          })}
        </Tabs>
        {customRightComponent}
        {customRightComponentSpace}
        {customRightComponent2}
      </Container>
    </div>
  );
};


Stepper.defaultProps = {
  customLeftComponent: null,
  customRightComponent: null,
  customRightComponentSpace: null,
  customRightComponent2: null,
  textColor: "primary",
  indicatorColor: "primary",
  hasCompletedStepIndicator: false,
  completedStepTextColor: "secondary",
  completedStepIndicatorColor: "secondary",
  containerProps: {},
  maxWidth: 'lg',
  disableGutters: false,
  variant: 'fullWidth',
  stepperZIndex: 1,
  disableRipple: false,
  sticky: true,
  onChange: null,
};

Stepper.propTypes = {
  className: PropTypes.string,
  /** Active step */
  activeStep: PropTypes.number.isRequired,
  /** Array of steps */
  steps: PropTypes.array.isRequired,
  /** Custom left component */
  customLeftComponent: PropTypes.element,
  /** Custom right component */
  customRightComponent: PropTypes.element,
  /** Custom right component space */
  customRightComponentSpace: PropTypes.element,
  /** Custom right component 2 */
  customRightComponent2: PropTypes.element,
  /** Tab's text color */
  textColor: PropTypes.string,
  /** Tab's indicator color */
  indicatorColor: PropTypes.string,
  /** Boolean required to show completed step indicator */
  hasCompletedStepIndicator: PropTypes.bool,
  /** Completed step's text color */
  completedStepTextColor: PropTypes.string,
  /** Completed step's indicator color */
  completedStepIndicatorColor: PropTypes.string,
  /** Tabs Container maxWidth */
  maxWidth: PropTypes.string,
  /** Disable gutters Tabs Container */
  disableGutters: PropTypes.bool,
  /** Additional props for Tabs Container */
  containerProps: PropTypes.object,
  /** Tabs variant */
  variant: PropTypes.string,
  /** z-index for stepper */
  stepperZIndex: PropTypes.number,
  /** Boolean required to disable Ripple effect */
  disableRipple: PropTypes.bool,
  /** Boolean required for sticky stepper */
  sticky: PropTypes.bool,
  /** Function called on clicking tabs */
  onChange: PropTypes.func
};

export default Stepper;